
export default class DateModel {

    #year;
    #month;
    #day;
    #week;

    year;
    month;
    day;
    week;

    constructor(dateObj){
        
        this.#year =  dateObj.getFullYear();
        this.#month = dateObj.getMonth();
        this.#day = dateObj.getDate();
        this.#week = dateObj.getDay();

        this.year = this.#year;
        this.month = this.#month + 1;
        this.day = this.#day;
        this.week = this.#week;
    }

    moveYear(move){
        const temp = new Date(this.#year + move, this.#month, this.#day);
        this.#year = temp.getFullYear();
        this.#week = temp.getDay();
        this.year = this.#year;
        this.week = this.#week;
        return temp;
    }

    moveMonth(move){
        const temp = new Date(this.#year, this.#month + move, this.#day);
        this.#month = temp.getMonth();
        this.#week = temp.getDay();
        this.month = this.#month + 1;
        this.week = this.#week;
        return temp;
    }

    moveDay(move){
        const temp = new Date(this.#year, this.#month, this.#day + move);
        this.#day = temp.getDate();    
        this.#week = temp.getDay();
        this.day = this.#day;   
        this.week = this.#week;
        return temp;
    }

    move(moveYear, moveMonth, moveDay){
        const temp = new Date(this.#year+ moveYear, this.#month + moveMonth, this.#day + moveDay);
        this.#year = temp.getFullYear();
        this.#month = temp.getMonth();
        this.#day = temp.getDate();
        this.#week = temp.getDay();

        this.year = this.#year;
        this.month = this.#month + 1;
        this.day = this.#day;
        this.week = this.#week;
        
        return temp;
    }

}